import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/app.svg',
})
export class AppComponent {}
